import qs from "qs";
import { Resource_Type_Identifier } from "@/utils/constant/teamManagement";
import urls from "@/urls";
import { fetchData } from "@/utils";
import { SOURCE_CODE_MAP } from "@/utils/constant/supplier";
import { Modal, Icon, message } from "@ss/mtd-react";
import { getFilePreviewUrl, UploadSourceType } from "@/utils/uploadSdk";
import { copyContent } from '@ss/mtd-fe-tool';
import { ActionType, ActionTypeMap } from "@/utils/constant/index";

// 图片格式优化
export function formatePicUrl(url, payload = {}) {
    if (!url) {
        return url
    }
    if (url.toLowerCase().includes('expires')) {
        return url
    }
    const { width = 500, height = 0, type = 'webp' } = payload;
    // @符号是不能图片处理的
    if (/@/.test(url)) {
        return url
    }
    // s3图片处理
    if (/s3plus/.test(url)) {
        return url.replace('s3plus', "s3plus-img") + `@${width}w.${type}`
    }
    // venus图片处理
    const VenusPicSymbol = [
        'p0.inf.test.sankuai.com',
        'p0.meituan.net',
        'p1.meituan.net',
        'img.meituan.net'
    ];
    for (const item of VenusPicSymbol) {
        if (url.includes(item)) {
            return url + `@${width}w@format=${type}`
        }
    }
    return url
}
// 组织架构名称截取
export function getOrgName() {
    const orgName = localStorage.getItem("userOrgName");
    const arr = orgName.split("-");
    if (arr.length >= 2) {
        const orgArr = arr.slice(2);
        return orgArr.join("-")
    } else {
        return orgName
    }
}

// 字符串时间转数字
export function formateTimeFromStringToNumber(time) {
    const arr = time.split(":");
    arr.reverse();
    let duration = 0;
    let rate = 1;
    for (const item of arr) {
        duration += rate * Number(item);
        rate *= 60;
    }
    return duration
}
export function formateTimeFromNumberToString(time) {
    const arr = [];
    while (time) {
        let cur = Math.floor(time % 60);
        arr.push(cur < 10 ? '0' + cur : cur)
        time = Math.floor(time / 60)
    }
    arr.reverse();
    if (arr.length === 1) {
        return "00:" + arr[0]
    } else {
        return arr.join(":")
    }
}
// 获取用户完整信息
export async function getUserFullInfo() {
    try {
        const res = await fetchData(urls.my.info);
        const { userId, mis, name, orgNamePath, orgPath, teamId, teamMis, teamName, teamAvatar, avatar } = res;
        return {
            userInfo: {
                userId: userId || '',
                userMis: mis || '',
                userName: name || '',
                userAvatar: avatar || '',
                userOrg: orgPath || '',
                userOrgName: orgNamePath || ''
            },
            teamInfo: {
                teamIds: teamId || [],
                teamNames: teamName || [],
                teamMises: teamMis || [],
                teamAvatars: teamAvatar || [],
            }
        }
    } catch (e) {
        return {
            userInfo: {
                userId: '',
                userMis: '',
                userName: '',
                userAvatar: '',
                userOrg: '',
                userOrgName: ''
            },
            teamInfo: {
                teamIds: [],
                teamNames: [],
                teamMises: [],
                teamAvatar: [],
            }
        }
    }

}
export async function getOwnTeam() {
    let teamIds, teamNames, teamMises, teamAvatars;
    teamIds = localStorage.getItem('teamIds');
    console.log("本地信息,", teamIds)
    if (!teamIds) {
        const { teamInfo } = await getUserFullInfo();
        teamIds = teamInfo.teamIds;
        teamNames = teamInfo.teamNames;
        teamMises = teamInfo.teamMises;
        teamAvatars = teamInfo.teamAvatars;
    } else {
        teamIds = JSON.parse(localStorage.getItem('teamIds'));
        teamNames = JSON.parse(localStorage.getItem('teamNames'));
        teamMises = JSON.parse(localStorage.getItem('teamMises'));
        teamAvatars = JSON.parse(localStorage.getItem('teamAvatars'));
    }
    const teamList = [];
    for (let i = 0; i < teamIds.length; i++) {
        const teamName = teamNames[i];
        const teamNameArr = teamName.split('-');
        const teamNameShort = teamNameArr[teamNameArr.length - 1]
        teamList.push({
            teamId: teamIds[i],
            teamMis: teamMises[i],
            teamName: teamNames[i],
            teamAvatar: teamAvatars[i],
            teamNameShort
        })
    }
    return teamList
}

// 获取团队信息
export async function getTeamInfo(teamId) {
    if (!teamId) {
        return null;
    }
    let teamIds, teamNames, teamMises, teamAvatars;
    teamIds = localStorage.getItem('teamIds');
    if (!teamIds) {
        const { teamInfo } = await getUserFullInfo();
        teamIds = teamInfo.teamIds;
        teamNames = teamInfo.teamNames;
        teamMises = teamInfo.teamMises;
        teamAvatars = teamInfo.teamAvatars;
    } else {
        teamIds = JSON.parse(localStorage.getItem('teamIds'));
        teamNames = JSON.parse(localStorage.getItem('teamNames'));
        teamMises = JSON.parse(localStorage.getItem('teamMises'));
        teamAvatars = JSON.parse(localStorage.getItem('teamAvatars'));
    }
    const index = teamIds.findIndex(item => String(item) === String(teamId));
    if (index > -1) {
        const teamName = teamNames[index];
        const teamNameArr = teamName.split('-');
        const teamNameShort = teamNameArr[teamNameArr.length - 1]
        return {
            teamId: teamIds[index],
            teamMis: teamMises[index],
            teamAvatar: teamAvatars[index],
            teamName,
            teamNameShort
        }
    }
    return null;
}

// 获取个人信息
export async function getUserInfo() {
    const userMis = localStorage.getItem("userMis");
    const userId = localStorage.getItem('userId')
    const userName = localStorage.getItem('userName');
    const userAvatar = localStorage.getItem('userAvatar');
    const userOrgName = localStorage.getItem('userOrgName');
    if (!userMis) {
        const { userInfo } = await getUserFullInfo();
        return {
            ...userInfo
        }
    } else {
        return {
            userId,
            userMis,
            userName,
            userAvatar,
            userOrgName
        }
    }
}

export function contains(root, n) {
    let node = n;
    while (node) {
        if (node === root) {
            return true;
        }
        node = node.parentNode;
    }

    return false;
}
// 取消上传
export function showCancelConfirm(title, handleOk, cancelText, okText) {
    Modal.confirm({
        title: <div className='flex-style'>
            <Icon type='warning-circle' style={{ color: '#FF5E00', fontSize: 24 }}></Icon>
            <span style={{ fontSize: 16, marginLeft: 8 }}>{title}</span>
        </div>,
        cancelText: cancelText || '暂不',
        okText: okText || '删除',
        okBtnProps: { type: "primary" },
        onOk: handleOk
    });
}

export function goBack(props) {
    if (window.history.length > 1) {
        props.history.go(-1);
    } else {
        window.location.replace('/px')
    }
}

export async function jumpToDaxiang(userMis) {
    let uid = ''
    try {
        uid = await fetchData(urls.uid, { userMis });
    } catch (e) {
        console.log(e)
    }

    window.open(`https://x.sankuai.com/bridge/chat?uid=${uid}`, "_blank")
}

export async function handleCopyText(text, message) {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
        message.success({ message: `复制${message}成功` });
    } else {
        message.error({ message: `复制${message}失败` });
    }
}

export function isPurchaseTypeMaterial(material, sourceIdentifier) {
    const { source } = material;
    const identifier = String(sourceIdentifier);
    if ((identifier === Resource_Type_Identifier.PX_IMAGE ||
        identifier === Resource_Type_Identifier.PX_AUDIO ||
        identifier === Resource_Type_Identifier.PX_VIDEO)
        // && Number(source) !== SOURCE_CODE_MAP.MT
    ) {
        return true
    }
    return false
}

export function isOfficialMaterial(sourceIdentifier) {
    if (!sourceIdentifier) {
        return false
    }
    const identifier = String(sourceIdentifier);
    if (identifier === Resource_Type_Identifier.BRAND_MATERIAL ||
        identifier === Resource_Type_Identifier.MARKET_MATERIAL ||
        identifier === Resource_Type_Identifier.PRODUCT_MATERIAL ||
        identifier === Resource_Type_Identifier.ICON ||
        identifier === Resource_Type_Identifier.CORPORATECULTURE_MATERIAL ||
        identifier === Resource_Type_Identifier.DESIGN_GUIDE
    ) {
        return true
    }
    return false
}

export function formateUploadFileList(fileList) {
    const materialFileList = [];
    if (!fileList && !Array.isArray(fileList)) {
        return materialFileList
    }
    for (const file of fileList) {
        if (!file.hasUploaded) {
            continue;
        }
        if (file.fileSourceType === UploadSourceType.MG_LINK) {
            materialFileList.push({
                fileSourceType: file.fileSourceType,
                fileCode: file.fileCode,
                fileName: file.fileName,
                fileUrl: file.fileUrl
            })
        } else {
            materialFileList.push({
                fileSourceType: file.fileSourceType || UploadSourceType.FILE,
                fileCode: file.fileCode,
                fileName: file.fileName,
                fileType: file.fileType,
                fileSize: file.fileSize,
                fileSizeSpc: file.fileSizeSpc,
                fileUrl: file.fileUrl
            })
        }
    }
    return materialFileList;
}

export function parseFileList(fileList) {
    const materialFileList = []
    if (!fileList && !Array.isArray(fileList)) {
        return materialFileList
    }
    for (const file of fileList) {
        const { fileCode, fileSourceType, fileName, fileType, fileSize, fileSizeSpc, fileUrl } = file;
        if (fileSourceType === UploadSourceType.MG_LINK) {
            materialFileList.push({
                fileSourceType,
                fileCode,
                fileName,
                fileUrl,
                filePreviewUrl: getFilePreviewUrl('mglink'),
                hasError: false,
                hasUploaded: true
            })
        } else {
            const filePreviewUrl = getFilePreviewUrl(fileType, fileName)
            materialFileList.push({
                fileSourceType,
                fileCode,
                fileName,
                fileUrl,
                fileType,
                fileSize,
                fileSizeSpc,
                filePreviewUrl,
                hasError: false,
                hasUploaded: true
            })
        }
    }
    return materialFileList;
}

export async function operationMaterial(activeType, materialType, materialCode, materialUrl, operateUsage) {
    try {
        const isInner = window.location.href.indexOf('assets-internal') > -1;
        let userInfo = {}
        if (isInner) {
            userInfo = await getUserInfo();
        }
        const params = {
            actionType: activeType,
            materialType: materialType,
            materialCode: materialCode,
            materialUrl: materialUrl || '',
            operateUsage: operateUsage || null,
            operator: userInfo?.userMis
        }
        await fetchData(isInner ? urls.materialoperaion : urls.materialoperaionOuter, params);
        if (activeType === ActionType.SHARE) {
            copyContent(window.location.href);
            message.success({
                message: `Sharing link copied to clipboard.`
            })
        } else if (activeType === ActionType.DOWNLOAD) {

        } else {
            message.success({
                message: `${ActionTypeMap[activeType]}success。`
            })
        }
    } catch (e) {
        console.log(e)
        message.error({
            message: `${ActionTypeMap[activeType]}失败。${e}`
        })

    }
}

export function getShortName(userType, userName) {
    userType = Number(userType);
    if (userType === 2) {
        const name = userName
        if (!name) return '-'
        const shortNameArr = name.split('-');
        return shortNameArr[shortNameArr.length - 1]
    }
    return userName
}

export function jumpToTeamPageOrDaxiang(material) {
    const { userType } = material;
    if (Number(userType) === 2) {
        const userId = material.userId || material.createUserId;
        window.open(`/assets-internal/teamhome?teamId=${userId}`)
    } else {
        jumpToDaxiang(material.userMis)
    }
}

// 获取路由参数
export function getLocationParams(params) {
    return qs.parse(params, { ignoreQueryPrefix: true });
}

// 深拷贝
export function deepClone(obj) {
    if (obj === null || typeof obj !== "object") {
        return obj;
    }

    let clone = Array.isArray(obj) ? [] : {};

    for (let prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            clone[prop] = deepClone(obj[prop]);
        }
    }

    return clone;
}

// 获取是否有品牌营销分类管理功能
export async function hasBrandManPermission() {
    const params = {
        userMis: localStorage.getItem('userMis')
    }
    return await fetchData(urls.marketMaterial.getBrandManPermission, params)
}

// 获取是否有菜单权限
export async function getPixelManPermission() {
    const params = {
        userMis: localStorage.getItem('userMis')
    }
    return await fetchData(urls.teamManage.getPixelManPermission, params)
}

// 从localstorage中获取购物车图标信息
export function getIconsInLs(){
    const iconsInLocalStorage = JSON.parse(localStorage.getItem('carts') || '[]')
    return new Set(iconsInLocalStorage)
}

export function setIconsInLs(value){
    localStorage.setItem('carts', JSON.stringify(Array.from(value)));
    window.dispatchEvent(new Event('cartsStorageChange'));
}

// 往localstorage的购物车中删除图标
export function deleteIconInLs(iconId){
    const icons = getIconsInLs();
    icons.delete(iconId);
    setIconsInLs(icons);
}

// 往localstorage的购物车中添加(批量)图标
export function addIconsInLs(iconIds){
    const icons = getIconsInLs();
    if( Array.isArray(iconIds)){
        iconIds.forEach(iconId => {
            icons.add(iconId);
        });
    }else {
        icons.add(iconIds);
    }
    setIconsInLs(icons);
}

